export default "__VITE_ASSET__5a191020__"